import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { segmentsCompareActions, bcActions } from 'src/store/actions';
import { SegmentsViewWrapper } from 'src/components';
import { GraphicPage } from 'src/containers';
import { parseQs } from 'src/functions';

import CONSTANTS from 'src/store/constants';

const FACTORS = 5;
const FACETS = 30;

function CompareSegments({
  location: { search },
  app: { tenant },
  segmentsCompare: { segments, fetchSegmentsStatus },
  fetchSegments,
  setSegmentNames,
}) {
  const getData = useCallback(() => {
    const { id } = parseQs(search.replace('?', ''));
    const query = {
      filters: [
        {
          and: [{ name: 'id', op: 'in', val: id }],
        },
      ],
    };
    fetchSegments(query);
  }, [fetchSegments, search]);

  const hasData =
    segments &&
    segments.length > 1 &&
    segments.reduce(
      (accumulator, segment) =>
        accumulator && segment && segment.pxScores && segment.pxScores.length >= FACTORS + FACETS
    );

  useEffect(() => {
    if (segments && segments.length > 0 && fetchSegmentsStatus === CONSTANTS.API.SUCCEEDED) {
      const names = segments.map(({ name, filter, dataset: { name: datasetName } }) =>
        filter === 'POPULATION_SNAPSHOT' ? datasetName : name
      );
      setSegmentNames(names);
    }
  }, [segments, fetchSegmentsStatus, setSegmentNames]);

  /*
   * Fetch data whenever the tenant or params change
   */
  useEffect(() => {
    if (tenant) getData();
  }, [tenant, getData]);

  const data = segments.map(({ dataset, name, filter, pxScores, ...rest }) => ({
    ...rest,
    dataset,
    filter,
    name: filter === 'POPULATION_SNAPSHOT' ? dataset.name : name,
    pxScores: pxScores.filter(({ trait: { subType } }) => subType !== 'factor'),
  }));

  return <SegmentsViewWrapper getData={getData} hasData={hasData} data={data} apiStatus={fetchSegmentsStatus} />;
}

const mapStateToProps = ({ app, bc, segmentsCompare }) => ({
  app,
  bc,
  segmentsCompare,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSegments: (query) => dispatch(segmentsCompareActions.fetchSegments(query)),
  setSegmentNames: (segmentNames) => dispatch(bcActions.setSegmentNames(segmentNames)),
});

CompareSegments.propTypes = {
  app: PropTypes.shape({
    tenant: PropTypes.string.isRequired,
  }).isRequired,
  segmentsCompare: PropTypes.shape({
    segments: PropTypes.arrayOf(
      PropTypes.shape({
        pxScores: PropTypes.arrayOf(PropTypes.shape({})),
        dataset: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
        }),
      })
    ).isRequired,
    fetchSegmentsStatus: PropTypes.oneOf([PropTypes.string, null]).isRequired,
  }).isRequired,
  fetchSegments: PropTypes.func.isRequired,
  setSegmentNames: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(GraphicPage(CompareSegments));
